/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Proof_4_VInputs */

const en_mk_proof_4_v = /** @type {(inputs: Mk_Proof_4_VInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Human approval`)
};

const id_mk_proof_4_v = /** @type {(inputs: Mk_Proof_4_VInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Persetujuan Anda`)
};

/**
* | output |
* | --- |
* | "Human approval" |
*
* @param {Mk_Proof_4_VInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_proof_4_v = /** @type {((inputs?: Mk_Proof_4_VInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Proof_4_VInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_proof_4_v(inputs)
	return en_mk_proof_4_v(inputs)
});